import {NumberInput} from 'platform/components';
import {Grid} from 'platform/foundation';

import {useController} from 'react-hook-form';

import i18n from '@dms/i18n';

import {useStepFieldRegistration} from '../hooks/useStepFieldRegistration';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {parseSeatCount} from '../utils/parseSeatCount';

export function SeatCountNumberField() {
  const {control, mandatoryFields, baseTestId} = useVehicleFormContext();
  useStepFieldRegistration('seatCount');

  const {field, fieldState} = useController({name: 'seatCount', control});

  // `seatCount` is stored as a single-element array (chips convention); map it to/from the scalar
  // NumberInput. The sub-grid caps the width to one column so it aligns with the fields above.
  return (
    <Grid columns={[1, 2, 2]}>
      <NumberInput
        name={field.name}
        value={parseSeatCount(field.value?.[0])}
        onChange={(value) => field.onChange(value !== null ? [String(value)] : [])}
        onBlur={field.onBlur}
        decimalPlaces={0}
        minStepperValue={1}
        isStepperVisible
        label={i18n.t('entity.vehicle.labels.numberOfSeatsFull')}
        isRequired={mandatoryFields.includes('seatCount')}
        isRecommended={mandatoryFields.includes('seatCount')}
        errorMessage={fieldState.error?.message}
        isInvalid={!!fieldState.error}
        data-testid={`seatCount-${baseTestId}`}
      />
    </Grid>
  );
}
